import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HomeComponent } from '../home.component';

@Component({
    selector: 'app-home-video',
    templateUrl: './home-video.component.html',
    styleUrls: ['./home-video.component.css'],
    standalone: false
})
export class HomeVideoComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<HomeComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public sanitizer: DomSanitizer) { }

  public videoLink: any;

  ngOnInit(): void {
    this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.link);
  }

  public closeDialog() {
    this.dialogRef.close();
  }

}
